module.exports = __webpack_public_path__ + "static/media/gray_02.7e2eac81.jpg";